// Helpers de período para os filtros de histórico (formato yyyy-MM-dd, aceito pelos
// <input type="date"> e pelos endpoints do backend).

// Formata um Date para "yyyy-MM-dd" no fuso local (sem converter para UTC).
export function formatarDataInput(date: Date): string {
    const ano = date.getFullYear()
    const mes = String(date.getMonth() + 1).padStart(2, "0")
    const dia = String(date.getDate()).padStart(2, "0")
    return `${ano}-${mes}-${dia}`
}

// Período padrão: últimos 7 dias (hoje e os 6 anteriores).
export function periodoPadrao7Dias(): { inicio: string; fim: string } {
    const hoje = new Date()
    const inicio = new Date()
    inicio.setDate(hoje.getDate() - 6)
    return { inicio: formatarDataInput(inicio), fim: formatarDataInput(hoje) }
}
